import api from './api';

// ─── Field Mapping Helpers ────────────────────────────────────────────────────

/**
 * Normalize a single API career object → app-friendly shape.
 * API uses: job_title, employment_type, experience_required, is_open
 * App uses: title, type, experience, status ('open'|'closed')
 */
const normalize = (item) => ({
  id:           item.id,
  title:        item.job_title        || item.title        || '',
  department:   item.department                            || '',
  location:     item.location                              || '',
  type:         item.employment_type  || item.type         || 'full-time',
  experience:   item.experience_required || item.experience || '',
  description:  item.description                          || '',
  requirements: item.requirements                         || '',
  status:       item.is_open === undefined
                  ? (item.status || 'open')
                  : (item.is_open ? 'open' : 'closed'),
  createdAt:    item.created_at       || item.createdAt    || null,
  updatedAt:    item.updated_at       || item.updatedAt    || null,
});

/**
 * Map app form values → API payload.
 */
const toPayload = (values) => ({
  job_title:           values.title,
  department:          values.department,
  location:            values.location,
  employment_type:     values.type,
  experience_required: values.experience,
  description:         values.description,
  requirements:        values.requirements,
  is_open:             values.status === 'open',
});

// ─── Career Service ───────────────────────────────────────────────────────────

export const careerService = {
  getAll: async (params = {}) => {
    const response = await api.get('/careers', { params });
    const raw = response.data;

    // API may return array directly OR { data: [...], total, ... }
    const list   = Array.isArray(raw) ? raw
                 : Array.isArray(raw.data) ? raw.data
                 : [];
    const total  = raw.total ?? list.length;
    const page   = raw.page ?? (params.page || 1);

    return {
      data: {
        careers:    list.map(normalize),
        total,
        page,
        totalPages: raw.totalPages ?? Math.ceil(total / (params.limit || 10)),
      },
    };
  },

  getById: async (id) => {
    const response = await api.get(`/careers/${id}`);
    const raw = response.data?.data ?? response.data;
    return { data: normalize(raw) };
  },

  create: async (values) => {
    return api.post('/careers', toPayload(values));
  },

  // API uses POST /careers/update/{id}
  update: async (id, values) => {
    return api.post(`/careers/update/${id}`, toPayload(values));
  },

  delete: async (id) => {
    return api.delete(`/careers/${id}`);
  },

  // API uses PATCH /careers/toggle/{id}
  toggleStatus: async (id) => {
    return api.patch(`/careers/toggle/${id}`);
  },
};
